import { ArticlesGrid } from '@gik/blog/components/ArticlesGrid/ArticlesGrid';
import WordpressConverter from '@gik/blog/utils/WordpressConverter';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';

type GivePageArticlesGridProps = {
  data: WordpressPost[];
  title: string;
};

export function GivePageArticlesGrid({ data, title }: GivePageArticlesGridProps) {
  const bem = bemBlock('give-page-articles');
  const isMdDown = useBreakpoint(Breakpoint.MD_DOWN);
  const articles = React.useMemo(
    () => data?.map(post => WordpressConverter.convertPost(post)).filter(WordpressConverter.filterOutPreviewContent),
    [data]
  );
  return <ArticlesGrid row={isMdDown} articles={articles} title={title} showCategory centeredTitle {...bem()} />;
}
